/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_SubtitleInputs */

const vi_reconcile_subtitle = /** @type {(inputs: Reconcile_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các khoản CK về ngân hàng chưa khớp đơn — gán vào đơn hoặc bỏ qua`)
};

/**

* @param {Reconcile_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_subtitle = /** @type {((inputs?: Reconcile_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_subtitle(inputs)
});